<template>
  <v-card flat height="calc(100vh - 106px)" class="overflow-y pt-4 pl-4">
    <v-form ref="form">
      <v-container fluid>
        <v-row>
          <v-col cols="11">
            <outlined-block title="Customer">
              <v-container>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-radio-group v-model="customer" dense hide-details class="mt-0"
                            @change="shopify.settings.customerForOrders = customer==='single'?shopify.settings.customerForOrders:null;
                                     shopify.settings.customerForExportOrders = customer==='single'?shopify.settings.customerForExportOrders:null ;
                                     $emit('saveSettings')">
                      <v-radio label="Use single customer for all Shopify orders" value="single" @click="validate()"/>
                      <v-radio label="Create customer in PURTRAK as required" value="create"/>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-select v-if="customer==='single'"
                              label="Customer for Canadian sales" :items="customers" item-value="id" item-text="name" :rules="[fieldRules.required]"
                              outlined dense hide-details v-model="shopify.settings.customerForOrders" @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer"
                              @click="newCustomerType='customerForOrders';defaultName='Shopify e-commerce sales';customerType='None';customerCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new customer
                        </div>
                      </template>
                    </v-select>
                    <v-select v-if="customer==='single'" class="mt-4"
                              label="Customer for export sales" :items="customers" item-value="id" item-text="name" :rules="[fieldRules.required]"
                              outlined dense hide-details v-model="shopify.settings.customerForExportOrders" @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newCustomerType='customerForExportOrders';customerType='Export';defaultName='Shopify e-commerce sales (export)';customerCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new customer
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>
                <v-row class="mt-4" align="center">
                  <v-col cols="12" sm="4">
                    <v-select label="Customer for POS orders" :items="customers" item-value="id" item-text="name" :rules="[fieldRules.required]"
                              outlined dense hide-details
                              v-model="shopify.settings.customerForPOS" @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newCustomerType='customerForPOS';customerType='None';defaultName='Shopify POS sales';customerCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new customer
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col class="text-caption">Used for in-person Shopify POS sales</v-col>
                </v-row>
              </v-container>
            </outlined-block>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11">
            <outlined-block title="Special items">
              <v-container class="mt-4">
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select :items="items" item-text="name" item-value="id" v-model="shopify.settings.shipmentItemId"
                              label="Shipping item" outlined dense
                              no-data-text="No items found" :rules="[fieldRules.required]"
                              @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newItemType='shipmentItemId';defaultName='Shopify shipping';itemCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption mt-n6">
                    PURTRAK item to use for Shopify shipping charges
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select :items="items" item-text="name" item-value="id" v-model="shopify.settings.giftCardItemId"
                              label="Gift card" outlined dense
                              no-data-text="No items found" :rules="[fieldRules.required]"
                              @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newItemType='giftCardItemId';defaultName='Shopify gift card';itemCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption mt-n6">
                    PURTRAK item to use for Gift Card purchases
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select :items="items" item-text="name" item-value="id" v-model="shopify.settings.customItemId"
                              label="Custom item" outlined dense
                              no-data-text="No items found" :rules="[fieldRules.required]"
                              @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newItemType='customItemId';defaultName='Shopify custom item';itemCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption mt-n6">
                    PURTRAK item to use for custom items added to orders
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select :items="items" item-text="name" item-value="id" v-model="shopify.settings.tipItemId"
                              label="Tip item" outlined dense
                              no-data-text="No items found" :rules="[fieldRules.required]"
                              @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newItemType='tipItemId';defaultName='Shopify tip';itemCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption mt-n6">
                    PURTRAK item to use for customer tips on orders
                  </v-col>
                </v-row>
<!--
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-select :items="items" item-text="name" item-value="id" v-model="shopify.settings.feesItemId"
                              label="Fees item" outlined dense
                              no-data-text="No items found"
                              @change="$emit('saveSettings')">
                      <template v-slot:prepend-item>
                        <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="newItemType='feesItemId';itemCreate=true">
                          <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new item
                        </div>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6" class="text-caption mt-n6">
                    PURTRAK item to use to account for Shopify transaction fees on orders
                  </v-col>
                </v-row>
-->
              </v-container>
            </outlined-block>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11">
            <outlined-block title="Invoice (Sales receipt)">
              <v-container class="mt-4">
                <v-row align="center">
                  <v-col cols="8" sm="4" lg="4">
                    <v-autocomplete label="Type" v-model="shopify.settings.paymentMethodId" :items="paymentMethods" item-value="id" item-text="name"
                                    outlined dense hide-details @change="$emit('saveSettings')" :rules="[fieldRules.required]"/>
                  </v-col>
                </v-row>
                <v-row v-if="connectedToAccounting" align="center">
                  <v-col cols="12" sm="9" lg=6>
                    <v-switch label="Create QuickBooks Online receipt for Shopify orders" v-model="shopify.settings.qbo" @change="$emit('saveSettings')"
                                hint="If you have Shopify integrated directly with QuickBooks Online, this should be off" persistent-hint/>
                  </v-col>
                  <v-col cols="12" sm="6" lg="4">
                    <account-picker v-model="shopify.settings.qboAccountRef" label="Account for payment" :accounts="accounts"
                                    hide-details @change="$emit('saveSettings')" :disabled="!shopify.settings.qbo" required/>
                  </v-col>
                </v-row>
              </v-container>
            </outlined-block>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="11">
            <outlined-block title="Processing">
              <v-container>
                <v-row align="center" class="mt-1">
                  <v-col cols="6" sm="3" lg="2">
                    <v-select label="Frequency" v-model="shopify.settings.orderProcessingFrequency"
                              :items="[{text:'Manually',value:'Never'},{text:'Daily',value:'Daily'},{text:'Hourly',value:'Hourly'},{text:'Real time',value:'RealTime'}]"
                              dense outlined hide-details @change="$emit('saveSettings')"/>
                  </v-col>
                  <v-col cols="12" sm="8" lg="6" class="text-caption">Shopify orders are processed <em>only</em> if they are completely fulfilled.</v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-switch label="Pull products from in-bond inventory" v-model="shopify.settings.inBond" hide-details
                              @click="checkDraftSetting()"/>
                  </v-col>
                </v-row>
                <v-row align="center" dense>
                  <v-col cols="12" sm="6" lg="4">
                    <v-switch v-model="shopify.settings.createDraftOrders" label="Create shipments as drafts" @change="$emit('saveSettings')"
                                :hint="draftMessage" persistent-hint :disabled="!!draftMessage" hide-details/>
                  </v-col>
                </v-row>
                <v-row align="center" dense>
                  <v-col cols="12" sm="8" lg="6">
                    <v-switch v-model="shopify.settings.createDraftOrdersOnLowInventory" label="Create shipments as drafts if low on inventory" @change="$emit('saveSettings')"/>
                  </v-col>
                </v-row>
              </v-container>
            </outlined-block>
          </v-col>
        </v-row>
        <v-row dclass="mt-4">
          <v-col cols="11">
            <outlined-block title="Process Shopify orders now">
              <v-container>
                <v-row align="center">
                  <v-col cols="8" sm="3">
                    <v-radio-group v-model="ordersBy" dense class="mt-0" hide-details>
                      <v-radio label="By date range" value="date"/>
                      <v-radio label="By order #" value="number"/>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="8" sm="5" md="4" v-if="ordersBy==='date'">
                    <date-range hide-details :from.sync="ordersFrom" :to.sync="ordersTo" option="Today"/>
                  </v-col>
                  <v-col cols="6" sm="2" v-else>
                    <v-text-field outlined dense hide-details v-model="orderNumber" :error="!orderNumber"/>
                  </v-col>
                  <v-col cols="7" sm="3">
                    <v-btn color="primary" :disabled="ordersBy==='number' && !orderNumber" @click="processOrders" :loading="loading">Process order{{ordersBy==='number'?'':'s'}}</v-btn>
                  </v-col>
                  <v-col cols="9" sm="4" md="3" v-if="ordersBy==='number'">
                    <v-checkbox label="Force reprocessing" v-model="forceReprocessing">
                      <template v-slot:append>
                        <v-tooltip top open-delay="1000" max-width="350">
                          <template v-slot:activator="{on}">
                            <v-icon v-on="on">mdi-help-circle</v-icon>
                          </template>
                          <div>
                            Fulfilled Shopify orders that are successfully processed to create shipments
                            will only be processed once.
                            You can, however, force reprocessing.
                            For example, if the created Shipment was deleted you might want to recreate it.
                          </div>
                        </v-tooltip>
                      </template>
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </outlined-block>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

    <customer-quick-create v-model="customerCreate" :customerType="customerType" :defaultName="defaultName" @create="newCustomer"/>
    <inventory-items-quick-create v-model="itemCreate" @create="newItem" type="Service" sold :defaultName="defaultName"/>
  </v-card>
</template>

<script>
import CustomerQuickCreate from '@/views/sales/customers/CustomerQuickCreate'
import InventoryItemsQuickCreate from '@/views/inventory/items/InventoryItemsQuickCreate'

export default {
  name: 'AppsShopifyOrders',
  components: {CustomerQuickCreate,InventoryItemsQuickCreate},
  props: {
    shopify: {type:Object, required:false}
  },
  data() {
    return {
      accounts: [],
      paymentMethods: [],
      items: [],
      customer: 'single',
      customers: [],
      customerCreate: false,
      defaultName: '',
      newCustomerType: '',
      customerType: 'None',
      ordersBy: 'date',
      ordersFrom: null,
      ordersTo: null,
      orderNumber: null,
      itemCreate: false,
      newItemType: '',
      forceReprocessing: false,
      loading: false
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    connectedToAccounting() {
      return this.company.connectedToAccounting;
    },
    draftMessage() {
      if (!this.shopify.settings.inBond && this.company.settings.lotTrackingForDutyPaid ||
          this.shopify.settings.inBond && this.company.settings.lotTrackingForProducts)
        return 'Shipments must be draft because of lot tracking';
    }
  },
  async created() {
    const data = await Promise.all([
      this.$store.dispatch('customers', true),
      this.$store.dispatch('items'),
//      this.$lazyListLoad(this.items, 'items2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'},{field:'type',comparator:'ne',value:'Item'}]),
      this.$lazyListLoad(this.paymentMethods, 'paymentMethods2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}])
    ]);
    this.customers = data[0];
    this.items = data[1].filter(item => item.active && item.type !== 'Item');

    const results = await this.$apiCall(`query AppsShopifyOrders($accounting:Boolean!) {
                                            accounts @include(if:$accounting) {
                                              ref,name,type,typeName,currency
                                            }
                                          }`,
                                        {accounting:this.connectedToAccounting});
    if (!results.error) {
      if (this.connectedToAccounting)
        this.accounts = results.data.accounts.filter(account => account.type === 'Bank' || account.type === 'CreditCard' || account.type === 'OtherCurrentAsset');
      this.customer = this.shopify.settings.customerForOrders ? 'single' : 'create';
    }
  },
  mounted() {
    this.validate();
  },
  methods: {
    checkDraftSetting() {
      if (!!this.draftMessage) {
        this.shopify.settings.createDraftOrders = true;
        this.$emit('saveSettings');
      }
    },
    validate() {
      this.$nextTick(() => this.$refs.form.validate());
    },
    async newCustomer(customer) {
      this.customers = await this.$store.dispatch('customers', true);
      this.shopify.settings[this.newCustomerType] = customer.id;
      this.$emit('saveSettings');
    },
    async newItem(item) {
      this.items = (await this.$store.dispatch('items')).filter(item => item.type !== 'Item');
      this.shopify.settings[this.newItemType] = item.id;
      this.$emit('saveSettings');
    },
    async processOrders() {
      this.loading = true;
      const results = await this.$apiCall(`mutation AppsShopifyOrders($from:Date!, $to:Date!, $number:String!, $byDate:Boolean!, $forceReprocessing:Boolean!) {
                                            shopifyProcessOrdersByDate(from:$from, to:$to) @include(if:$byDate) {total,errors}
                                            shopifyProcessOrdersByNumber(number:$number, forceReprocessing:$forceReprocessing) @skip(if:$byDate) {total,errors}
                                          }`,
                                          {from:this.ordersFrom,to:this.ordersTo,number:this.orderNumber||'',byDate:this.ordersBy==='date', forceReprocessing:this.forceReprocessing},
                                          false, 'shopify');
      this.loading = false;
      if (!results.error) {
        const orders = this.ordersBy==='date' ? results.data.shopifyProcessOrdersByDate : results.data.shopifyProcessOrdersByNumber;
        this.$store.commit('setError', {type:orders.errors?'warning':'success',
                                        message:`${orders.total} order(s) processed with ${orders.errors} error(s)${orders.errors?' (See Shopify log for details)':''}`});
      }
    }
  }
}
</script>
